import { ServerNode } from "../../nodes/nodes.types";

export function trimDescription(node: ServerNode) {
  return node.description?.trim();
}

